import {css} from '@emotion/css';

const styles = {
  container: css`
    label: trustpilotWidget__container;
    width: 100%;
  `,
};

export default styles;
